import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { BankAccount } from "../../models/bank-account.model";

@Component({
  selector: "ngx-bank-account-form",
  templateUrl: "./bank-account-form.component.html",
  styleUrls: ["./bank-account-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BankAccountFormComponent extends BaseFormComponent<BankAccount> {
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.apiName = "BankAccount";
    this.label = "حساب بانکی";
    super.ngOnInit();
  }
  setdefault() {
    if (this.model.Active === undefined) this.model.Active = true;
    if (this.model.StartDate === undefined) this.model.StartDate = new Date();
  }
}
